import React, { useState, useMemo } from "react";
import { Popover, Tag, Checkbox, Input, Empty } from "antd";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import { ButtonItem } from "./Items";
import "./Styles.css";

function CheckListPickerItem(props) {
  const {
    value,
    onChange,
    groups = [],
    placeholder,
    disabled,
    width,
    style,
    noBuscar,
    className,
  } = props;

  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const selected = Array.isArray(value) ? value : [];

  const labelByValue = useMemo(() => {
    const map = {};
    groups.forEach((g) => g.items.forEach((it) => { map[it.value] = it.label; }));
    return map;
  }, [groups]);

  const filteredGroups = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return groups;
    return groups
      .map((g) => {
        const groupMatches = g.label?.toLowerCase().includes(term);
        const items = groupMatches ? g.items : g.items.filter((it) => it.label?.toLowerCase().includes(term));
        return { ...g, items };
      })
      .filter((g) => g.items.length > 0);
  }, [groups, search]);

  const combinedStyle = { ...(width ? { width } : {}), ...style };

  if (disabled) {
    const text = selected.map((v) => labelByValue[v] ?? v).join(", ");
    return (
      <div className={`select-readonly ${className || ""}`} style={combinedStyle} title={text}>
        {text || placeholder || ""}
      </div>
    );
  }

  const toggleValue = (val) => {
    const next = selected.includes(val)
      ? selected.filter((v) => v !== val)
      : [...selected, val];
    onChange?.(next);
  };

  const removeTag = (val, e) => {
    e.stopPropagation();
    onChange?.(selected.filter((v) => v !== val));
  };

  const content = (
    <div className="checklist-picker-popover-content">
      {!noBuscar && (
        <Input
          allowClear
          placeholder="Buscar proyecto..."
          prefix={<SearchOutlined />}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ marginBottom: 8 }}
        />
      )}
      <div className="checklist-picker-list">
        {filteredGroups.length === 0 ? (
          <Empty description="Sin resultados" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          filteredGroups.map((g) => (
            <div key={g.key} className="checklist-picker-group">
              <div className="checklist-picker-group-label">{g.label}</div>
              {g.items.map((it) => (
                <div
                  key={it.value}
                  className="checklist-picker-row"
                  onClick={() => toggleValue(it.value)}
                >
                  <Checkbox
                    checked={selected.includes(it.value)}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => toggleValue(it.value)}
                  />
                  <span style={{ marginLeft: 8 }}>{it.label}</span>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
      <div className="checklist-picker-footer">
        <ButtonItem size="small" cyan onClick={() => setOpen(false)}>Listo</ButtonItem>
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottomLeft"
      overlayClassName="checklist-picker-popover"
    >
      <div className={`checklist-picker-trigger ${className || ""}`} style={combinedStyle}>
        {selected.length === 0 ? (
          <span className="checklist-picker-placeholder">{placeholder}</span>
        ) : (
          <div className="checklist-picker-tags">
            {selected.map((v) => (
              <Tag key={v} closable onClose={(e) => removeTag(v, e)}>
                {labelByValue[v] ?? v}
              </Tag>
            ))}
          </div>
        )}
        <DownOutlined className="checklist-picker-arrow" />
      </div>
    </Popover>
  );
}

export default CheckListPickerItem;
